import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import type {BackendStatus} from '../../interfaces/Backend';

type BlastMode = {
  timeout: number | null;
  status: boolean;
};

type BackendState = {
  backend: BackendStatus | null;
  blastMode: BlastMode;
};

const initialState: BackendState = {
  backend: null,
  blastMode: {
    timeout: null,
    status: false,
  },
};

const backendSlice = createSlice({
  name: 'backend',
  initialState,
  reducers: {
    setBackend: (state, action: PayloadAction<BackendStatus>) => {
      state.backend = action.payload;
    },
    setBlastMode: (state, action: PayloadAction<BlastMode>) => {
      state.blastMode = action.payload;
    },
    clearBackend: (state) => {
      state.backend = null;
      state.blastMode = {timeout: null, status: false};
    },
  },
});

export const {setBackend, setBlastMode, clearBackend} = backendSlice.actions;
export default backendSlice.reducer;
